import React from "react";
import { render } from "react-dom";

import {
  ConfigAppSDK,
  FieldAppSDK,
  SidebarAppSDK,
  DialogAppSDK,
  EditorAppSDK,
  PageAppSDK,
  init,
  locations,
} from "@contentful/app-sdk";
import { GlobalStyles } from "@contentful/f36-components";
import "./index.css";

import Config from "./components/ConfigScreen";
import EntryEditor from "./components/EntryEditor";
import Page from "./components/Page";
import Sidebar from "./components/Sidebar";
import Field from "./components/Field";
import Dialog from "./components/Dialog";

import LocalhostWarning from "./components/LocalhostWarning";

if (process.env.NODE_ENV === "development" && window.self === window.top) {
  // You can remove this if block before deploying your app
  const root = document.getElementById("root");
  render(
    <>
      <GlobalStyles />
      <LocalhostWarning />
    </>,
    root
  );
} else {
  init((sdk) => {
    const root = document.getElementById("root");

    // All possible locations for your app
    // Feel free to remove unused locations
    // Dont forget to delete the file too :)
    const ComponentLocationSettings = [
      {
        location: locations.LOCATION_APP_CONFIG,
        component: <Config sdk={sdk as ConfigAppSDK} />,
      },
      {
        location: locations.LOCATION_ENTRY_FIELD,
        component: <Field sdk={sdk as FieldAppSDK} />,
      },
      {
        location: locations.LOCATION_ENTRY_EDITOR,
        component: <EntryEditor sdk={sdk as EditorAppSDK} />,
      },
      {
        location: locations.LOCATION_DIALOG,
        component: <Dialog sdk={sdk as DialogAppSDK} />,
      },
      {
        location: locations.LOCATION_ENTRY_SIDEBAR,
        component: <Sidebar sdk={sdk as SidebarAppSDK} />,
      },
      {
        location: locations.LOCATION_PAGE,
        component: <Page sdk={sdk as PageAppSDK} />,
      },
    ];

    // Select a component depending on a location in which the app is rendered.
    ComponentLocationSettings.forEach((componentLocationSetting) => {
      if (sdk.location.is(componentLocationSetting.location)) {
        render(
          <>
            <GlobalStyles />
            {componentLocationSetting.component}
          </>,
          root
        );
      }
    });
  });
}
